import React from 'react'
import * as icon from '../../assets/images/utility-icons/truv-verified-mark.svg'

function VerifiedMark() {
  return (
    <div className="verified-mark-container">
      <img src={icon} alt="Income is verified" />
      <div className="label">Verified</div>
    </div>
  )
}

export default React.memo(VerifiedMark)
